import BaseApi from './base'

class PortalUser extends BaseApi {
  getPortalUserList = (query) => this.client.get(`admin/portal-users?${query}`)

  addPortalUser = (data) => this.client.post('admin/portal-users', data)

  updatePortalUser = ({ userId, params }) =>
    this.client.patch(`admin/portal-users/${userId}`, params)

  getPortalUserDetail = (userId) =>
    this.client.get(`admin/portal-users/${userId}`)

  upsertGDPRPortalUser = ({ userId, params }) =>
    this.client.put(`admin/portal-users/${userId}/optin`, params)

  getGDPRPortalUser = ({ userId, platformTechKey }) =>
    this.client.get(`admin/portal-users/${userId}/optin/${platformTechKey}`)

  getVehiclePortalUser = ({ userId, params }) =>
    this.client.get(`admin/portal-users/${userId}/vehicles`, { params })

  getCompaniesPortalUser = (userId) =>
    this.client.get(`admin/portal-users/${userId}/companies`)

  updateRolePortalUser = ({ userId, params }) =>
    this.client.post(`admin/user-app/${userId}/roles`, params)

  getRolePortalUser = (userId) =>
    this.client.get(`admin/user-app/${userId}/roles`)

  getDirectVehiclesPortalUser = (id, query) =>
    this.client.get(`/admin/direct-vehicles/${id}?${query}`)

  cancelDirectVehiclePortalUser = (id) =>
    this.client.post(`/admin/direct-vehicles/cancel/${id}`, {})

  getCommSystemLogsPortalUser = ({ userId, persId, params }) => {
    if (userId) {
      return this.client.get(`/user/${userId}/comm-system-log`, { params })
    }
    return this.client.get(`/pers/${persId}/comm-system-log`, { params })
  }
}

export default new PortalUser()
